import { Box, styled } from '@mui/material';

import { Colors } from 'Themes/colors';
import { Spacing } from 'Themes/spacing';

export const StyledWrapper = styled(Box)`
  display: flex;
  margin-bottom: 10px;
  background: ${Colors.white};
  position: relative;
  height: 76px;
  align-items: center;
  &:before {
    content: '';
    background: ${Colors.white};
    position: absolute;
    height: 100%;
    width: 100vw;
    z-index: -1;
    margin: 0 calc(-50vw + 50%);
  }
` as typeof Box;

export const NavbarDivider = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex: 1;
`;

export const NavbarSide = styled(Box)`
  display: flex;
  align-items: center;
  gap: 24px;
  flex: 1;
`;

export const NavbarCenter = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  gap: ${Spacing.small};
`;

export const NavbarLeft = styled(NavbarSide)`
  justify-content: flex-start;
`;

export const NavbarRight = styled(NavbarSide)`
  justify-content: flex-end;
`;
